import { useRef, useCallback } from 'react';

import { updateChecklistItem, removeChecklistItem } from 'actions/checklists';

import { useVerticalDnD } from 'hooks/dnd';

import TaskListItem from 'components/TaskListItem';
import DraggableItem from 'components/DraggableItem';
import ChecklistItemActions from './ChecklistItemActions';

const ChecklistItem = ({ checklistId, index, item, canEdit, moveItem }) => {
    const itemCtrl = useRef(null);

    const handleComplete = () => {
        updateChecklistItem(checklistId, item.id, { completed: true });
    }

    const handleUncomplete = () => {
        updateChecklistItem(checklistId, item.id, { completed: false });
    }

    const handleNameChange = (itemId, name) => {
        updateChecklistItem(checklistId, item.id, { name });
    }

    const handleRemove = () => {
        removeChecklistItem(checklistId, item.id);
    }

    const handleEditNameClick = () => {
        requestAnimationFrame(() => {
            itemCtrl.current?.beginEdit();
        });
    }

    return (
        <TaskListItem
            ref={itemCtrl}
            id={item.id}
            task={item}
            isSubtask={true}
            draggable={canEdit}
            dragType={checklistId}
            editOnDoubleClick={true}
            showComplete={true}
            checkSubtasks={false}
            dontFetchDep={true}
            canEdit={canEdit}
            onComplete={handleComplete}
            onUncomplete={handleUncomplete}
            onNameChange={handleNameChange}
            onRemove={handleRemove}
            moveItem={moveItem}
            actionsElement={canEdit ? <ChecklistItemActions
                className="item-actions"
                innerClassName="btn btn-square btn-xxxsmall btn-simple btn-icon item-click-action"
                onEditNameClick={handleEditNameClick}
                onRemove={handleRemove}
            /> : <></>}
        />
    );
}

export default ChecklistItem;
